export enum FileType {
  CSV = 'csv',
  PDF = 'pdf',
  XLS = 'xls',
}

export enum FileUploadType {
  BOM_ATTACHMENT = 'bom_attachment',
  BOM_IMPORT = 'bom_import',
  PART_DATASHEET = 'part_datasheet',
  PART_IMAGE = 'part_image',
  PRICING_PROFILE_ATTACHMENT = 'pricing_profile_attachment',
  QUOTE_ATTACHMENT = 'quote_attachment',
  VENDOR_QUOTE_IMPORT = 'vendor_quote_import',
}

export enum MimeType {
  CSV = 'text/csv',
  GIF = 'image/gif',
  JPEG = 'image/jpeg',
  PDF = 'application/pdf',
  PNG = 'image/png',
  SVG = 'image/svg+xml',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ZIP = 'application/zip',
}

export enum FileExtension {
  CSV = '.csv',
  GIF = '.gif',
  JPEG = '.jpeg',
  JPG = '.jpg',
  PDF = '.pdf',
  PNG = '.png',
  SVG = '.svg',
  XLS = '.xls',
  XLSX = '.xlsx',
}
